import "./HeroImg4Styles.css";

import React from 'react';


const HeroImg4 = () => {
  return (
    <div className="hero-img3">
        <div className="heading">
            <h1>About</h1>
            <p>This is me</p>
        </div>
    </div>
  );
};

export default HeroImg4